import React, { useEffect, useState } from "react";
import axios from "axios";
import useEmirateFromCoordinates, { BACKEND_URL, ImageURL } from "../common/Common.js";
import { Link, useNavigate, useParams } from 'react-router-dom';
import "../banners/Banners.css"

//Navbar and Left Section Images
import hayatin from '../../assets/images/hayatin.jpg';
import homeicon from '../../assets/home-images/homeicon.jpg';
import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
import plusicon from '../../assets/home-images/plusicon.png';
import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
import videos from '../../assets/home-images/videos.png';
import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import flagicon from '../../assets/home-images/flagicon.png';
import expbanner from '../../assets/experience/Expbanner.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';

import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import businessicon1 from '../../assets/experience/businessicon1.png';
import nodata from '../../assets/experience/nodata.png';


import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import downarrowicon from '../../assets/categorylist/downarrowicon.png';
import filtericon from '../../assets/categorylist/filtericon.png';
import mapicon from '../../assets/categorylist/mapicon.png';
import menuicon from '../../assets/categorylist/menuicon.png';
import vertical_line from '../../assets/categorylist/vertical_line.png';
import Navbar from "../common-component/navbar/Navbar.js";
import LeftSection from "../common-component/left-menu-section/LeftSection.js";
import leftarrow from '../../assets/offers/leftarrow.png';

const countryicons = [omanflag, qatarflag, kuwaitflag, ksaflag]

const Banners = () => {
    const navigate = useNavigate();
    const { bannerId } = useParams();
    const [offers, setOffers] = useState([]); // offer page list get api state
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]); // countrylist get api state
    const [selectedState, setSelectedState] = useState(null);
    const [filterpopup, setFilterpopup] = useState(false);
    const [categories, setCategories] = useState([]);
    const [showcatgoryname, setShowcategoryname] = useState(false)
    const [openoffertype, setOpenoffertype] = useState(false);
    const [offertype, setOffertype] = useState({});
    const [selectedOfferTypes, setSelectedOfferTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [leftMenuOpen, setLeftMenuOpen] = useState(false);


    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const selectedBanner = offers
        .flatMap((offer) => offer.banners || [])
        .find((banner) => banner && banner.banner_id && banner.banner_id.toString() === bannerId);

    const allBannerItems = selectedBanner && selectedBanner.banner_items ? selectedBanner.banner_items : [];

    // Filter banner items based on search term (client-side filtering for letters, words, numbers)
    const bannerItems = searchTerm.trim()
        ? allBannerItems.filter((item) => {
            const searchLower = searchTerm.toLowerCase().trim();
            const couponTitle = (item.coupon_title || "").toLowerCase();
            const userName = (item.user_name || "").toLowerCase();
            const location = (item.location || "").toLowerCase();
            const discountValue = String(item.discount_value || "").toLowerCase();
            const couponPrice = String(item.coupon_price || "").toLowerCase();
            const discountPrice = String(item.discount_price || "").toLowerCase();
            const discountType = (item.discount_type || "").toLowerCase();

            return (
                couponTitle.includes(searchLower) ||
                userName.includes(searchLower) ||
                location.includes(searchLower) ||
                discountValue.includes(searchLower) ||
                couponPrice.includes(searchLower) ||
                discountPrice.includes(searchLower) ||
                discountType.includes(searchLower)
            );
        })
        : allBannerItems;

    const bannerItemsCount = bannerItems.length;

    const togglecategoryname = () => {
        setShowcategoryname(!showcatgoryname);
    };

    const toggleOfffertype = () => {
        setOpenoffertype(!openoffertype)
    }

    const matchedCategories = Array.isArray(bannerItems) && Array.isArray(categories)
        ? bannerItems
            .map((item) => categories.find((cat) => cat && cat.id === item.category_id))
            .filter(Boolean)
            .filter(
                (cat, index, arr) =>
                    index === arr.findIndex((c) => c.id === cat.id)
            )
        : [];


    const matchedOfferTypes = offertype && offertype.discounttypeData && Array.isArray(offertype.discounttypeData)
        ? offertype.discounttypeData
            .filter((off) =>
                bannerItems.some((item) => item.discount_type_id == off.id)
            )
            .filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.id === value.id)
            )
        : [];

    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedOfferTypes([...selectedOfferTypes, id]);
        } else {
            setSelectedOfferTypes(selectedOfferTypes.filter((item) => item !== id));
        }
    };

    const clearAllFilters = () => {
        setSelectedOfferTypes([]);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const toggleLeftMenu = () => {
        setLeftMenuOpen(!leftMenuOpen);
    };


    // const fetchOffers = async () => {
    //     const params = {
    //         latitude: latitude,
    //         longitude: longitude,
    //         state_id: emirate?.id || "",
    //         user_id: "",
    //     };

    //     console.log("API params being sent:", params);

    //     try {
    //         const response = await axios.get(`${BACKEND_URL}website/getofferspagelist`, { params });
    //         setOffers(response.data);
    //         console.log("DATA+++", response.data)
    //     } catch (error) {
    //         console.error("Error fetching offers:", error);
    //     }
    // };
    const fetchOffers = async () => {
        const params = {
            latitude: latitude,
            longitude: longitude,
            state_id: selectedState?.id || emirate?.id || "",
            user_id: "",
            search: searchTerm.trim() || "",
        };

        console.log("API params being sent:", params);

        try {
            setIsLoading(true);
            const response = await axios.post(`${BACKEND_URL}website/getofferspagelist`, params);
            setOffers(response.data);
            console.log("DATA+++", response.data);
        } catch (error) {
            console.error("Error fetching offers:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMasterData = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-master-data`);
            if (response.data.stateData) {
                setStates(response.data.stateData);
            } else {
                setStates([]);
            }
        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/categories`);
            // Handle different possible response structures
            let categoriesData = [];
            if (response.data) {
                if (Array.isArray(response.data)) {
                    categoriesData = response.data;
                } else if (response.data.data && Array.isArray(response.data.data)) {
                    categoriesData = response.data.data;
                } else if (response.data.categories && Array.isArray(response.data.categories)) {
                    categoriesData = response.data.categories;
                }
            }
            setCategories(categoriesData);
        } catch (error) {
            console.error("Error fetching categories:", error);
            setCategories([]);
        }
    };

    const fetchOffertype = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-common-data`);
            setOffertype(response.data || {});
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching offer types:", error);
            setOffertype({});
        }
    }



    // Load selected state from localStorage on mount
    useEffect(() => {
        const savedState = localStorage.getItem('selectedState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                setSelectedState(parsedState);
                const lat = parseFloat(parsedState.latitude || parsedState.lat || 24.4539);
                const lng = parseFloat(parsedState.longitude || parsedState.lng || 54.3773);
                setLatitude(lat);
                setLongitude(lng);
            } catch (error) {
                console.error("Error parsing saved state:", error);
            }
        }
    }, []);

    useEffect(() => {
        // Only use geolocation if no saved state exists
        if (!localStorage.getItem('selectedState') && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    setLatitude(24.4539);
                    setLongitude(54.3773);
                }
            );
        } else if (!localStorage.getItem('selectedState')) {
            setLatitude(24.4539);
            setLongitude(54.3773);
        }
    }, []);

    // Handle location change from country popup
    const handleStateChange = (state) => {
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        console.log("🟢 Location Selected:", state.name, "Lat:", lat, "Lng:", lng);

        setSelectedState(state);
        setLatitude(lat);
        setLongitude(lng);
        setCountrypopup(false);

        localStorage.setItem('selectedState', JSON.stringify(state));
    };
    useEffect(() => {
        if (!latitude || !longitude) return;
        fetchOffers();
        fetchMasterData();
        fetchCategories();
        fetchOffertype();
    }, [latitude, longitude, emirate, selectedState, searchTerm]);

    return (
        <div>
            <Navbar />

            <div className="experience-main-layout">
                {/* Overlay for closing menu */}
                {leftMenuOpen && (
                    <div
                        className="menu-overlay"
                        onClick={() => setLeftMenuOpen(false)}
                    ></div>
                )}
                <div className={`left-section-wrapper ${leftMenuOpen ? 'menu-open' : ''}`}>
                    <LeftSection />
                </div>

                <main className="experience-middle-section">
                    <div className="mid-section-head-div">
                        <img src={expbanner} alt="enjoy summer" className="enjoy-summer-img" />
                    </div>


                    {(isLoading || (Array.isArray(bannerItems) && bannerItems.length > 0)) && (
                        <div className="banner-menu-map-filter-div">
                            <div className="menu-map-filter-div">
                                <img src={menuicon} alt="menu icon" className="menu-icon" />
                                {/* <img src={mapicon} alt="map icon" className="map-icon" /> */}
                                <img src={vertical_line} alt="vertical line" className="vertical-line" />
                                <img src={filtericon} alt="filter icon" className="filter-icon" onClick={() => setFilterpopup(true)} />
                            </div>
                        </div>
                    )}



                    <div className="category-title bannerpage">
                        <h6>
                            <span className="desktop-title website-banners"><span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>Experience /</span> Banners</span>
                            <span className="mobile-tablet-title handpicked"><span onClick={() => navigate(-1)} >Experience /</span> Handpicked for You</span>
                        </h6>
                        {/* <p className="desktop-offers-count">{bannerItemsCount} offers</p> */}
                    </div>


                    {/* Mobile/Tablet Search Box (320px - 992px) */}
                    <div className="mobile-search-filter-container">
                        <div className="mobile-searchbox">
                            <img src={search} alt="search" />
                            <input
                                type="text"
                                placeholder="Search offers..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>

                        <img
                            src={filtericon}
                            alt="filter"
                            className="mobile-filter-icon"
                            onClick={() => setFilterpopup(true)}
                        />
                    </div>

                    <div className="offers-grid-container">
                        {isLoading ? (
                            // 🔄 Shimmer loading skeleton
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={`shimmer-${index}`} className="offer-card-grid shimmer-card">
                                    <div className="offer-img-wrapper-grid shimmer-image"></div>
                                    <div className="offer-details-grid">
                                        <div className="shimmer-line shimmer-location"></div>
                                        <div className="shimmer-line shimmer-title"></div>
                                        <div className="shimmer-line shimmer-subtitle"></div>
                                        <div className="shimmer-line shimmer-price"></div>
                                    </div>
                                </div>
                            ))
                        ) : Array.isArray(bannerItems) && bannerItems.length > 0 ? (
                            bannerItems.map((item, index) => {
                                let discountText;

                                switch (item.discount_type_id) {
                                    case 8:
                                    case 4:
                                        discountText = <span className="offer-tag">{item.discount_type}</span>;
                                        break;

                                    case 7:
                                        discountText = (
                                            <span className="offer-tag">
                                                {item.discount_value
                                                    ? `${item.discount_value}% OFF`
                                                    : item.discount_type}
                                            </span>
                                        );
                                        break;

                                    case 5:
                                        discountText = (
                                            <span className="offer-tag">
                                                Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                                            </span>
                                        );
                                        break;

                                    case 1:
                                        discountText =
                                            item.discount_value && item.discount_price && item.coupon_price ? (
                                                <>
                                                    <span className="old-price">AED {item.coupon_price}</span>
                                                    <span className="new-price">AED {item.discount_price}</span>
                                                    <span className="separator">|</span>
                                                    <span className="discount">{item.discount_value}% OFF</span>
                                                </>
                                            ) : (
                                                <span className="offer-tag">AED {item.coupon_price}</span>
                                            );
                                        break;

                                    case 10:
                                        discountText = (
                                            <span className="discount_type_from">
                                                From{" "}
                                                <span className="discount_coupon_price">
                                                    AED {item.coupon_price}
                                                </span>
                                            </span>
                                        );
                                        break;

                                    default:
                                        discountText =
                                            item.discount_type === "Total" ? (
                                                <span className="offer-tag">
                                                    {item.discount_value}% OFF
                                                </span>
                                            ) : (
                                                <span className="offer-tag">{item.discount_type}</span>
                                            );
                                }

                                return (
                                    <Link
                                        to={`/offers/${item.coupon_id}/${item.category_id}`}
                                        className="remove-underline"
                                        key={item.coupon_id || index}
                                    >
                                        <div className="offer-card-grid">
                                            <div className="offer-img-wrapper-grid banners">
                                                <img
                                                    src={item.coupon_image}
                                                    alt={item.coupon_title}
                                                />
                                            </div>

                                            <div className="offer-details-grid">
                                                <p className="offer-location">
                                                    <img
                                                        src={businessicon}
                                                        alt="logo"
                                                        className="bussinessicon"
                                                    />
                                                    <span>{item.user_name}</span>
                                                </p>

                                                <h4>{item.coupon_title}</h4>

                                                <p className="limited-deals-distance">
                                                    {Math.round(item.distance)} km | {item.location}
                                                </p>

                                                <div className="offer-prices">{discountText}</div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })
                        ) : (
                            // No data UI
                            <div className="nodata-message-categorylist">
                                <img src={nodata} alt="no data" className="no-data-img" />
                                <p className="no-data-p1">No offers found</p>
                                <p className="no-data-p2">Come back later to explore</p>
                            </div>
                        )}
                    </div>


                </main>


                {/* Country pop up */}
                {countrypopup && (
                    <>
                        {/* Overlay */}
                        <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>

                        {/* Centered Popup */}
                        <div className="custom-popup">
                            <div className="custom-popup-header">
                                <h4>Choose Your Location</h4>
                                <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                            </div>

                            {/* States List */}
                            <div className="custom-popup-body">
                                <div className="state-grid">
                                    {states.filter((state) => Number(state.country_id) === 1)
                                        .map((state, index, arr) => {
                                            const isDisabled = index >= arr.length - 4; // last 4 items

                                            return (
                                                <div
                                                    key={state.id}
                                                    className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                    onClick={() => !isDisabled && handleStateChange(state)}
                                                >
                                                    <img
                                                        src={index < 2 ? flagicon : countryicons[index - 2]}
                                                        alt="flag"
                                                        className="flagicon-popup"
                                                    />
                                                    <p>{state.name}</p>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </>
                )
                }

                {filterpopup && (
                    <>
                        <div className="overlay" onClick={() => setFilterpopup(false)}></div>
                        <div className="popup-drawer">
                            <div className="popup-header">
                                <h4></h4>
                                <img src={xmark} alt="xmark" className="close-popup" onClick={() => setFilterpopup(false)} />
                            </div>

                            <div className="filter-list">

                                <div className="filter-section">
                                    <div className="filter-header" onClick={togglecategoryname}>
                                        <h6 className="filter-title">Categories</h6>
                                        <img
                                            src={downarrowicon}
                                            alt="down arrow"
                                            className={`sub-down-arrow-icon ${showcatgoryname ? "rotate" : ""}`}
                                        />
                                    </div>
                                    {showcatgoryname && (
                                        <div className="filter-checkbox-list">
                                            {matchedCategories.map((sub) => (
                                                <label key={sub.id} className="filter-checkbox-item">
                                                    <input
                                                        type="checkbox"
                                                        value={sub.id}
                                                        checked={selectedOfferTypes.includes(sub.id)}
                                                        onChange={(e) => handleCheckboxChange(e, sub.id)}
                                                    />
                                                    {sub.category_name}
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="filter-section">
                                    <div className="filter-header" onClick={toggleOfffertype}>
                                        <h6 className="filter-title">Offer Type</h6>
                                        <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${openoffertype ? "rotate" : ""}`} />
                                    </div>
                                    {openoffertype && (
                                        <div className="filter-checkbox-list">
                                            {matchedOfferTypes?.map((off) => (
                                                <label key={off.id} className="filter-checkbox-item">
                                                    <input
                                                        type="checkbox"
                                                        value={off.id}
                                                        checked={selectedOfferTypes.includes(off.id)}
                                                        onChange={(e) => handleCheckboxChange(e, off.id)}
                                                    />
                                                    {off.discount_type}
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="filter-buttons-bottom">
                                    <button className="clear-btn" onClick={clearAllFilters}>Clear All</button>
                                    <button className="show-btn">Show Result</button>
                                </div>
                            </div>

                        </div>
                    </>
                )}
            </div >

        </div>
    )
}


export default Banners



